module.exports = __webpack_public_path__ + "static/img/5.be4af42.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wepb/5.webp
// module id = yqU7
// module chunks = 1